export default {"src":"/_next/static/media/line.951f6d6a.svg","height":41,"width":31,"blurWidth":0,"blurHeight":0};